import requestModule from '@/application/libs/requestModule'
import Util from  '@/application/libs/util'

const _getCDFILIAL = () => Util.getFilterInSession().CDFILIAL;
const _getCDSERVFILI = () => Util.getFilterInSession().CDSERVFILI;
const _getIDTIPORESTRICAO = () => Util.getFilterInSession().TPCONTRATO;
const _getDTMESCARD = () => Util.getFilterInSession().DTMESCARD;
const _getIDUTRPADCA = () => Util.getFilterInSession().IDUTRPADCA;
const _getNRORG = () => Util.getLocalVar("userData").NRORG;


export default {
    getDashData(){
        return requestModule.postRequest('getData', {
            FROM: "DASHBOARD",
            PARAMS: {}
        }).then(response => response.dataset?.data);
    },
    getFiliais(){
        return requestModule.postRequest('getData', {
            FROM: 'FILIAL',
            PARAMS: {
                CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
            },
        }).then(response => response.dataset?.data || []);
    },
};
